var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.793 10.7072L7.793 15.7071C7.8858 15.8 7.9961 15.8736 8.1174 15.9239C8.2387 15.9741 8.3687 16 8.5 16C8.7652 16 9.0195 15.8947 9.207 15.7071C9.2998 15.6143 9.3735 15.5041 9.4237 15.3828C9.474 15.2615 9.4998 15.1315 9.4998 15.0002C9.4998 14.735 9.3945 14.4807 9.207 14.2931L5.914 11.0001L17.5 11.0001C17.7652 11.0001 18.0196 10.8948 18.2071 10.7073C18.3946 10.5197 18.5 10.2654 18.5 10.0001C18.5 9.73492 18.3946 9.48062 18.2071 9.29302C18.0196 9.10552 17.7652 9.00012 17.5 9.00012L5.914 9.00012L9.207 5.70712C9.3945 5.51962 9.4998 5.26532 9.4998 5.00012C9.4998 4.73502 9.3945 4.48062 9.207 4.29312C9.0195 4.10562 8.7652 4.00032 8.5 4.00032C8.2348 4.00032 7.9805 4.10562 7.793 4.29312L2.793 9.29312C2.7001 9.38592 2.6263 9.49612 2.576 9.61742C2.5257 9.73872 2.4998 9.86882 2.4998 10.0001C2.4998 10.1315 2.5257 10.2615 2.576 10.3828C2.6263 10.5042 2.7001 10.6144 2.793 10.7072Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.79ff8011c654f63874f50f699f33dd58.svg";
export { ForwardRef as ReactComponent };